import { render, staticRenderFns } from "./workerListForth.vue?vue&type=template&id=a44f3c6a&scoped=true"
import script from "./workerListForth.vue?vue&type=script&lang=js"
export * from "./workerListForth.vue?vue&type=script&lang=js"
import style0 from "./workerListForth.vue?vue&type=style&index=0&id=a44f3c6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44f3c6a",
  null
  
)

export default component.exports